import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

const FreeIdentityDialog = ({
  open,
  name,
  loading,
  onClose,
  onConfirm,
}: {
  open: boolean;
  name: string;
  loading: boolean;
  onClose: () => void;
  onConfirm: () => void;
}) => {
  return (
    <Dialog open={open} onClose={() => !loading && onClose()}>
      <DialogTitle>Free this identity?</DialogTitle>
      <DialogContent>
        <DialogContentText component="div">
          This frees <strong>{name || "this account"}</strong>'s phone, email,
          and any NUX invitee email for reuse — e.g. so they can sign up again
          as a member. The account and its conversations are preserved, but
          these values become available to a new account. This cannot be undone
          from here.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={onConfirm}
          disabled={loading}
        >
          Free identity
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FreeIdentityDialog;
